import { __extends } from "tslib";
/**
 * @description Generate safe instruction for null block usage
 */
var CallBlockSaver = /** @class */ (function () {
    function CallBlockSaver() {
        this._block = null;
        this._used = false;
        this._needSafe = false;
    }
    CallBlockSaver.prototype.test = function (mn) {
        return false;
    };
    CallBlockSaver.prototype.markToSafe = function (mn) {
        return this._needSafe = this.test(mn);
    };
    CallBlockSaver.prototype.drop = function () {
        // we can drop already used block
        if (this._used) {
            return;
        }
        this._needSafe = false;
        this._block = undefined;
    };
    CallBlockSaver.prototype.safe = function (alias) {
        this._block = { alias: alias };
        this._used = false;
        return true;
    };
    CallBlockSaver.prototype.needSafe = function (alias) {
        return this._needSafe && this._block && this._block.alias === alias;
    };
    CallBlockSaver.prototype.beginSafeBlock = function (alias) {
        if (!this.needSafe(alias)) {
            return '';
        }
        this._used = true;
        return "if(" + this._block.alias + " != undefined) {"; // push block end;
    };
    CallBlockSaver.prototype.endSafeBlock = function (fallback) {
        if (!this._used) {
            return '';
        }
        var result = fallback ? "} else { " + this._block.alias + " = " + fallback + "; }" : '}';
        this._used = false;
        this._block = undefined;
        return result;
    };
    CallBlockSaver.prototype.reset = function () {
        this._block = null;
        this._needSafe = false;
        this._used = false;
    };
    return CallBlockSaver;
}());
export { CallBlockSaver };
var TweenCallSaver = /** @class */ (function (_super) {
    __extends(TweenCallSaver, _super);
    function TweenCallSaver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TweenCallSaver.prototype.test = function (mn) {
        var _a;
        return mn.namespaces && ((_a = mn.namespace) === null || _a === void 0 ? void 0 : _a.uri) && mn.namespace.uri.includes('TweenLite');
    };
    return TweenCallSaver;
}(CallBlockSaver));
export { TweenCallSaver };
